import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {RiCloseLine, RiFileCopyLine} from "react-icons/ri";
import {
    Backdrop, Card, Header, Title, CloseBtn, Body, Label, LinkRow, LinkText, CopyBtn, Copied, Advanced,
} from "./styles";

/**
 * InviteModal — "Invite of group" (espelho): mostra o link de convite da campanha
 * (roteia pra um grupo disponível) + botão copiar. Tem um atalho "avançado" pro add-por-número.
 */
const InviteModal = ({open, link, onClose, onAdvanced}) => {
    const {t} = useTranslation();
    const [copied, setCopied] = React.useState(false);

    React.useEffect(() => {
        if (open) setCopied(false);
    }, [open]);

    if (!open) return null;

    const copy = () => {
        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(link).then(() => setCopied(true)).catch(() => setCopied(true));
        } else {
            setCopied(true);
        }
    };

    return (
        <Backdrop onClick={onClose}>
            <Card onClick={(e) => e.stopPropagation()}>
                <Header>
                    <Title>{t("words.invite_of_group")}</Title>
                    <CloseBtn type="button" aria-label={t("words.cancel")} onClick={onClose}><RiCloseLine/></CloseBtn>
                </Header>
                <Body>
                    <Label>{t("words.link_invite")}</Label>
                    <LinkRow>
                        <LinkText href={link} target="_blank" rel="noopener noreferrer">{link}</LinkText>
                        <CopyBtn type="button" aria-label={t("words.copy")} onClick={copy}><RiFileCopyLine/></CopyBtn>
                    </LinkRow>
                    {copied && <Copied>{t("words.link_copied")}</Copied>}
                    <div>
                        <Advanced type="button" onClick={onAdvanced}>{t("words.add_by_number")}</Advanced>
                    </div>
                </Body>
            </Card>
        </Backdrop>
    );
};

InviteModal.propTypes = {
    open: PropTypes.bool,
    link: PropTypes.string,
    onClose: PropTypes.func,
    onAdvanced: PropTypes.func,
};

export default InviteModal;
